module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2ElEQVR4AeWQNV5GMRAH57/J+wyHA9Dgrj1WUXNcrgAd3lLjznss7u42TZLV+YVvRwDTNU3OG+hbXZTxAAnCAQMC4Bexh4jcYdMzZtN9lrL9K0UHGkOetligQvb0gIiYSneZPNy8MklxxpJyumLheQNDFCWWs0NS/GpoIWcY97gfCwJDdMQCEREv7gEI6HkDAXUWGM9VUpLhOMNJBQUJiecNBNRbjoGkSAAMMZgUz2JCL/uD/lgkSEzkq3GgJRTIzDnAnx8AnBf6qXo5ALt+xGNEniDF+QccA3U5MYbGWXGbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AL.png
// module id = 1072
// module chunks = 0